import { VStack } from '@ayble-health/dashboard-components';
import { IFrame } from '../UserDashboard/IFrame';
import React from 'react';

const { REACT_APP_HEALTHIE_URL } = process.env;

export const CalendarPage = () => {
  return (
    <VStack h={'100vh'}>
      <IFrame src={`${REACT_APP_HEALTHIE_URL}/organization `} />
    </VStack>
  );
};

export default CalendarPage;
